import {
  COFFEE_GET_SETTINGS_REQUESTING,
  COFFEE_MODIFY_SETTINGS_REQUESTING,
  COFFEE_CHANGE_SETTINGS,
  COFFEE_CLOSE_SNACK_MESSAGE
} from "./constants";

export const getCoffeeSettingsRequest = (payload: {}) => {
  return {
    type: COFFEE_GET_SETTINGS_REQUESTING,
    payload
  };
};

export const modifyCoffeeSettingsRequest = payload => {
  return {
    type: COFFEE_MODIFY_SETTINGS_REQUESTING,
    payload
  };
};

export const changeCoffeeSettings = payload => {
  return {
    type: COFFEE_CHANGE_SETTINGS,
    payload
  };
};

export const closeSnackMessage = () => {
  return {
    type: COFFEE_CLOSE_SNACK_MESSAGE
  };
};
